/* eslint-disable max-len */
export const GDPRFileDownload = { url: "/gdpr-file-download/%7BfileId%7D", type: undefined as { fileId: string | number; } };
